import Variable from '../../constants/constants.json';
import { LIST_CUSTOM_LOGIN_USERS } from '../Constants/customLoginUsers.constants';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const { createRequest } = require('../../api/client');

export const getCustomLoginUsersList = () => async (dispatch) => {
    const options = {
        url: `${Variable.backendUrl}/customLoginAccess/getCustomLoginUsers`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    };
    try {
        const result = await createRequest(options);
        dispatch({
            type: LIST_CUSTOM_LOGIN_USERS,
            data: result.data
        });
    } catch (err) {
        handleExcception(err);
        dispatch({
            type: LIST_CUSTOM_LOGIN_USERS,
            data: {}
        });
    }
};
